<template>
  <div class="content">
    <div class="head">
      <div class="searchOne">
        <el-select v-model="queryParams.userId" filterable placeholder="代理商" @change="search" clearable>
          <el-option v-for="item in agentOptions" :key="item.userId" :label="item.company" :value="item.userId"></el-option>
        </el-select>
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable></el-input>
      </div>
      <span class="span-but">
        <button type="button" class="el-button icon-button-auto el-button--default el-button--small" @click="hidden">
          <i class="el-icon-d-arrow-right" :class="{rotating:an}"></i>
        </button>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetForm">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="adds">新增</el-button>
        <el-button type="primary" icon="el-icon-download" @click="handleExport">导出</el-button>
      </span>
      <div v-show="an" class="array-class">
        <el-input v-model="queryParams.phone" placeholder="手机号"  @keyup.enter.native="search" clearable></el-input>
        <el-input v-model="queryParams.remark" placeholder="备注"  @keyup.enter.native="search" clearable></el-input>
        <el-select v-model="queryParams.status" default-first-option filterable placeholder="状态" @change="search" clearable>
          <el-option v-for="item in tystatus" :key="item.value" :label="item.label" :value="item.value" ></el-option>
        </el-select>
        <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="searchTime"
            @change="search"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </div>
    </div>
    <div class="content-class">
      <div style="margin-top: 10px">
        <el-table 
          :data="tableData" 
          ref="tableData"
          border 
          v-loading="loading"
          @sort-change="tableSortChange"
        >
          <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="username" label="代理商" align="center"></el-table-column>
          <el-table-column prop="iccid" label="ICCID" align="center" width="190px"></el-table-column>
          <el-table-column prop="name" label="联系人" align="center"></el-table-column>
          <el-table-column prop="phone" label="联系方式" align="center"></el-table-column>
          <el-table-column prop="price" label="收费金额" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="{row}">
              <el-tag v-if="row.status =='1'">使用中</el-tag>
              <el-tag v-else type="warning">已废弃</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="updateTime" label="更新日期" align="center" sortable="custom"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center"></el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
							<el-button size="mini" type="danger" @click="abandoned(scope.row.iccid)" style="background:#F39494;border: 1px solid #F39494" v-if="scope.row.status == '1'">废弃</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 弹窗部分 -->
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" v-dialogDrag width="550px" :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" ref="form" :rules="rules">
        <el-form-item label="代理商：" prop="userId" label-width="100px">
          <el-select v-model="form.userId" filterable clearable placeholder="请选择代理商" style="width: 300px">
            <el-option v-for="(item,index) in agentOptions" :key="index" :label="item.company" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="ICCID：" prop="iccid" label-width="100px">
          <el-input v-model="form.iccid" autocomplete="off" style="width: 300px" placeholder="请输入ICCID"></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" prop="phone" label-width="100px">
          <el-input v-model="form.phone" autocomplete="off" style="width: 300px" placeholder="请输入联系方式"></el-input>
        </el-form-item>
        <el-form-item label="收费金额：" prop="price" label-width="100px">
          <el-input v-model="form.price" autocomplete="off" style="width: 300px" placeholder="请输入收费金额"></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status" label-width="100px">
          <el-switch v-model="form.status" active-color="#13ce66" inactive-color="#DCDFE6" active-value="1" inactive-value="0" @change="changeSwitch($event)"></el-switch>
        </el-form-item>
        <el-form-item label="联系人：" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off" style="width: 300px" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark" label-width="100px">
          <el-input v-model="form.remark" autocomplete="off" style="width: 300px" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog()">取消</el-button>
        <el-button type="success" @click="saveInfo()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addUnBindCardRecord } from "@/api/api.js"; //新增
import { outsideList } from "@/api/api.js"; //列表
import { delUnBindCardRecord } from "@/api/api.js"; //废弃
import { agentSingleList } from "@/api/api.js"; //获取代理商下拉列表
import { exportOutSideCard } from "@/api/api.js"; //导出

export default {
  name:'cardSettings',
  data() {
    return{
      an:false,
      queryParams:{},
      tableData:[],
      searchTime:[],
      page: 1,
      pageSize: 20,
      total:0,
      // 弹窗部分
      title:"",
      dialog:false,
      loading:true,
      form:{
        status:"1"
      },
      rules:{
        iccid:[
          { required: true, message: "请输入ICCID", trigger: "blur" },
          { min: 17, max: 20, message: "请输入17至20位数字或字母",trigger: "blur" },
        ],
        phone:[
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        price:[
          { required: true, message: "请输入金额", trigger: "blur" },
        ],
        userId:[
          { required: true, message: "请输入代理商", trigger: "blur" },
        ]
      },
      tystatus:[
        { value: "2",label: "已废弃" },
        { value: "1",label: "使用中" },
      ],
      agentOptions:[],
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
    }
  },
  methods: {
    hidden(){
      this.an = this.an == false ? true : false;
    },
    // 搜索
    search() {
      this.tableData = [];
      this.page = 1;
      this.initData();
    },
    // 重置
    resetForm() {
      for (var i in this.queryParams) {
        this.queryParams[i] = null;
      };
      this.tableData = [];
      this.page = 1;
      this.searchTime = [];
      this.sortOrder = "";
      this.sortName = "";
      this.$refs.tableData.clearSort();
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    changeSwitch($event){
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order == "descending" ? "desc" : "asc";
      this.sortName = val.prop == "createTime" ? "createTime" : "updateTime";
      this.initData();
    },
    // 获取列表的数据
    initData(){
      let params= {
        model:{
          ...this.queryParams,
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      if (this.searchTime && this.searchTime[0]) {
        params.model.startTime = this.searchTime[0];
        params.model.endTime = this.searchTime[1];
      };
      this.loading = true;
      this.tableData = [];
      outsideList(params).then(res=>{
        if (res.data.code == 200) {
          this.loading = false;
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index)=>{
            item.ids = index + 1
          })
        }else{
          this.$message.error(res.data.message);
          this.loading = false;
        }
      })
    },
    // 新增
    adds(){
      this.title = "新增卡号";
      this.dialog = true;
      for(let i in this.form) {
        this.form[i] = "";
        this.form["status"] = "1"
      }
    },
    // 弹窗的取消
    cancelDialog(){
      this.dialog = false;
    },
    // 弹窗的保存
    saveInfo(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.title == "新增卡号") {
            let params ={
              ...this.form
            }
            addUnBindCardRecord(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: '成功',
                  message: '新增卡号成功',
                  type: 'success',
                  offset:30
                });
                this.dialog = false;
                this.initData();
              }else{
                this.$message.error(res.data.message);
              }
            })
          }else{
            let params ={
              ...this.form
            }
            autoDeductionUpdateProductRule(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: '成功',
                  message: '编辑套餐规则成功',
                  type: 'success',
                  offset:30
                });
                this.dialog = false;
                this.initData();
              }
            })
          }
        }
      })
    },
    // 弹窗的x
    dialogClose(){
      this.$refs.form.clearValidate();
      this.dialog = false;
    },
    // 获取代理商数据
    agentData(){
      agentSingleList().then(res=>{
        if(res.data.code == 200){
          this.agentOptions = res.data.data;
        }
      })
    },
    // 废弃按钮
    abandoned(id){
      let params = {
        iccid:id
      }
      this.$confirm('此操作将作废掉这张卡的使用, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delUnBindCardRecord(params).then(res=>{
          if (res.data.code == 200) {
            this.$notify({
              title: '成功',
              message: '已废弃成功',
              type: 'success',
              offset:30
            });
            this.initData();
          }else{
            this.$message.error("作废失败");
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消废弃'
        });          
      });
    },
    // 流量卡导出
    handleExport(){
      let params = {
        ...this.queryParams,
      };
      if (this.searchTime && this.searchTime[0]) {
        params.startTime = this.searchTime[0];
        params.endTime = this.searchTime[1];
      }
      this.$alert("确定要流量卡导出吗？", "流量卡导出", {
        confirmButtonText: "确定"
      }).then(() => {
        exportOutSideCard(params).then(res => {
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "列表导出成功，请在任务中心查看",
              type: "success",
              offset:30
            });
          }
        });
      });
    }
  },
  mounted() {
    this.initData();
    this.agentData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
  /deep/ .el-loading-mask{
    z-index: 1;
  }
}
</style>


